import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';




@Injectable({
  providedIn: 'root'
})
export class GruposService {

  gruposURL = environment.apiURL + 'sgc/grupos';
  gruposByIdUrl = environment.apiURL + 'sgc/grupos/grupo';

  constructor(private http: HttpClient) { }

  getGrupos(): Observable<any> {
    const url = this.gruposURL;
    return this.http.get<any[]>(url);
  }

  getGruposByIdCurso(id): Observable<any> {
    const url = this.gruposURL + '/' + id;
    return this.http.get<any>(url);
  }

  getGrupoById(id): Promise<any> {
    const urlGet = this.gruposByIdUrl + '/' + id;
    return this.http.get<any>(urlGet).toPromise();
  }

}
